import { loadConfig } from 'actions/global';

import storage from './storage';
import authStorage from './authStorage';

export const loadConfigFromLocalStorage = store => {
	// Load token
	const tokenData = authStorage.getToken();
	const tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: '',
	};

	const token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

	const cookieData = storage.getItem('cookie');
	const cookieDefault = { display: true };

	const cookie = cookieData === null ? cookieDefault : JSON.parse(cookieData);

	store.dispatch(loadConfig({ token, cookie }));
};



// WEBPACK FOOTER //
// ./src/util/external.js